var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgVideoRecPlay = function SvgVideoRecPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 120,
    rx: 10,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 120,
    rx: 10,
    fill: "url(#videoRecPlay_svg__paint0_linear_11_257)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.51 30.745l25.509 25.51-25.51 25.51.4-25.51-.4-25.51z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "videoRecPlay_svg__paint0_linear_11_257",
    x1: 90,
    y1: -6.223,
    x2: 90,
    y2: 141.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })))));
};
export default SvgVideoRecPlay;